import { unref, type Ref } from "vue";
import type { EmissionQuoteContext } from "@/types/emission.types";
import type { QuoteData } from "@/types/quote.types";

export function maintainExpandMode(): void {
  document.body.dispatchEvent(
    new CustomEvent("cotizador:results-view", {
      detail: {
        action: "expand",
        message: "Mantener modo expandido durante acciones del formulario",
      },
    }),
  );
}

export function toQuoteContext(
  quote: Ref<QuoteData> | QuoteData,
): EmissionQuoteContext {
  const q = unref(quote);
  return {
    year: q.year,
    brand: q.brand,
    type: q.type ?? null,
    amis: q.amis,
    model: q.model,
    personalData: q.personalData ?? null,
    cotizacionData: q.cotizacionData,
  };
}
